import { useNavigate, useLocation } from "react-router-dom";
import { UrlHelper } from "utils/helpers";

interface NavigationState {
  goBack: () => void;
  getRouteStateValue: (fieldName: string) => any;
  removeRouteStateValue: (fieldName: string) => void;
  navigateToPreviousLocation: (state: any) => void;
}

function useNavigationHistory(): NavigationState {
  const location = useLocation();
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 2) navigate(-1);
    else navigate(UrlHelper.formatPath("/"));
  };

  const getRouteStateValue = (fieldName: string) => {
    const state = (location.state as any) ? { value: (location.state as any)[fieldName] } : {};
    return state.value;
  };

  const removeRouteStateValue = (fieldName: string) => {
    navigate(location, {
      replace: true,
      state: {
        ...(location.state as any),
        [fieldName]: undefined,
      },
    });
  };

  const navigateToPreviousLocation = (state: any) => {
    const prevLocation = getRouteStateValue("background");
    if (prevLocation) navigate(prevLocation, { state: state });
  };

  return {
    goBack,
    getRouteStateValue,
    removeRouteStateValue,
    navigateToPreviousLocation,
  };
}

export default useNavigationHistory;
